var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper"},[_c('div',{staticClass:"content"},[(_vm.$route.meta && _vm.$route.meta.keepAlive)?[_c('keep-alive',[_c('router-view')],1)]:_c('router-view')],2),_c('tab-bar',{attrs:{"config":_vm.config},on:{"change":_vm.onChange},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }